var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "actions-collapsed-list" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-function exit-collapsed-list",
        on: { click: _vm.collapseActions }
      },
      [
        _c("i", {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip.right.hover",
              value: _vm.$t("CANCEL"),
              expression: "$t('CANCEL')",
              modifiers: { right: true, hover: true }
            }
          ],
          staticClass: "glyphicon glyphicon-chevron-left",
          attrs: { "aria-hidden": "true" }
        })
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "action-icon" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-list-function",
          on: { click: _vm.editPredictiveRouting }
        },
        [
          _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.bottom.hover",
                value: _vm.$t("EDIT"),
                expression: "$t('EDIT')",
                modifiers: { bottom: true, hover: true }
              }
            ],
            staticClass: "typcn typcn-edit",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("span", {
            directives: [
              { name: "t", rawName: "v-t", value: "EDIT", expression: "'EDIT'" }
            ],
            staticClass: "hint-text-mobile"
          })
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "action-icon" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-list-function m-t-3",
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.duplicatePredictiveRouting }
        },
        [
          _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.bottom.hover",
                value: _vm.$t("DUPLICATE"),
                expression: "$t('DUPLICATE')",
                modifiers: { bottom: true, hover: true }
              }
            ],
            staticClass: "fa fa-files-o",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("span", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "DUPLICATE",
                expression: "'DUPLICATE'"
              }
            ],
            staticClass: "hint-text-mobile"
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }